export default __webpack_public_path__ + "static/media/TheSeagullsOfKristiansund60s.eb879def.mp3";